import React, { useState } from 'react'
import ImageWrapper from './ImageWrapper'
import ModalPopUp from './ModalPopUp'

const VideoWrapper = ({ ThumbnailUrl, VideoUrl, MaxWidth, MaxHeight, PlayBtnUrl, VideoFunction }) => {
    
    return (
        <>
            <div className="video_main_wrapper" style={{ maxWidth: `${MaxWidth}px`, maxHeight: `${MaxHeight}px` }} onClick={() => VideoFunction(({ 'showVideo':true, 'videoUrl': VideoUrl }))}>
                <span className='video_play_btn'>
                    <ImageWrapper ImgUrl={PlayBtnUrl} />
                </span>
                <video className='video_wrapper' style={{ maxWidth: `${MaxWidth}px`, maxHeight: `${MaxHeight}px` }} autoPlay muted poster={ThumbnailUrl}>
                </video>
            </div>
        </>
    )
}

export default VideoWrapper